import { put, call, take, select, all } from 'redux-saga/effects'
import { makePushEvent } from '@devicebits/analytics-client'
import { CREATE_USER_EVENT, CREATE_FOOTPRINT } from './constants'
import { createFootprint } from './actions'
import { apiCreateFootprint } from './services'
import { selectCurrentTutorialSteps } from '../Tutorials/selectors'
import { fetchCustomerApi } from '../App/services'
import { selectCustomer } from '../App/selectors'
import { getParam } from '../../helpers/parameters'
import { getSessionId } from '../../helpers/getSessionId'
import { getPermanentId } from '../../helpers/getPermanentId'

const appStartTime = new Date()
const appId = window.GLOBAL_APP_ID || Math.uuid()

const getAnalyticsApiUrl = async () => {
  const analyticsApiUrl = await getParam('analyticsApiUrl')
  return `${analyticsApiUrl}/analytics/academy`
}

const pushEvent = makePushEvent({
  apiUrl: getAnalyticsApiUrl(),
  debounceDelay: 5000,

  baseProps: {
    app_instance_id: window.GLOBAL_APP_ID || Math.uuid(),
    app_instance_time: () => (
      (new Date() - appStartTime).toString()
    ),
    page: () => ({
      url: window.location.href
    }),
    user_agent: navigator.userAgent,
    timestamp: () => new Date().toISOString(),
    session_id: getSessionId(),
    permanent_id: getPermanentId(),
  }
})

export default function* rootSaga() {
  function* createFootprintWorker(contact) {
    const state = yield select()
    const customer = state.devicebits.customer
    const footprint = {
      first_name: contact.footprintFName,
      last_name: contact.footprintLName,
      email: contact.footprintEmail,
      phone: contact.footprintPhone,
      customer,
      sessionId: getSessionId(),
      permId: getPermanentId(),
      appId: appId
    }
    const response = yield call(apiCreateFootprint, footprint)
    if (response) {
      yield put(createFootprint.success(response))
    }
  }

  function* eventWatcher() {
    while (true) {
      const { event } = yield take(CREATE_USER_EVENT)
      let customer = yield select(selectCustomer)

      if (!customer) {
        const response = yield call(fetchCustomerApi, '')
        customer = Object.keys(response.styleRoot)[0]
      }

      const userEvent = event.data || {}
      userEvent.event_category = event.category

      if (
        event.category === 'tutorials' &&
        event.data.step_to !== 'undefined'
      ) {
        const stepRaw = event.data.step_to
        const state = yield select()
        const primarySteps = selectCurrentTutorialSteps(state)
        const matchedStep =
          1 + primarySteps.findIndex(step => step.arrayLoc === stepRaw)

        if (matchedStep > 0) {
          userEvent.step_to_pretty = {
            step: matchedStep,
            of: primarySteps.length
          }
        }
      }
  
      pushEvent({
        category: event.category,
        data: {
          ...userEvent,
          customer,
          // referrer in pageview only
          referrer: event.category === 'pageviews' ?
            { url: window.location.href } :
            undefined
        }
      }).catch(err => {
        console.error('Events send to analytics failed', err)
      })
    }
  }

  function* footprintWatcher() {
    while (true) {
      const payload = yield take(CREATE_FOOTPRINT.REQUEST)
      yield call(createFootprintWorker, payload.contact)
    }
  }

  yield all([
    call(eventWatcher),
    call(footprintWatcher),
  ])
}



// WEBPACK FOOTER //
// ./src/containers/UserEvents/sagas.js